/* eslint-disable no-unused-vars */

export enum BankingAbilitySubject {
  BANKING_ACCOUNTS_LOAD_NEW = 'Banking:Accounts:load_new',
  BANKING_ACCOUNTS = 'Banking:Accounts',
  BANKING_ACCOUNTS_GUID = 'Banking:Accounts:Guid',
  BANKING_ACCOUNTS_UPDATE_GUID = 'Banking:Accounts:Update:Guid',
  BANKING_ACCOUNTS_DELETE_GUID = 'Banking:Accounts:Delete:Guid',
  BANKING_JOURNALS_LOAD_NEW = 'Banking:Journals:load_new',
  BANKING_JOURNALS = 'Banking:Journals',
  BANKING_JOURNALS_GUID = 'Banking:Journals:Guid',
  BANKING_JOURNALS_UPDATE_GUID = 'Banking:Journals:Update:Guid',
  BANKING_JOURNALS_DELETE_GUID = 'Banking:Journals:Delete:Guid',
  BANKING_RULES_LOAD_NEW = 'Banking:Rules:load_new',
  BANKING_RULES = 'Banking:Rules',
  BANKING_RULES_GUID = 'Banking:Rules:Guid',
  BANKING_RULES_UPDATE_GUID = 'Banking:Rules:Update:Guid',
  BANKING_RULES_DELETE_GUID = 'Banking:Rules:Delete:Guid',
  BANKING_TAX_CODES_LOAD_NEW = 'Banking:TaxCodes:load_new',
  BANKING_TAX_CODES = 'Banking:TaxCodes',
  BANKING_TAX_CODES_GUID = 'Banking:TaxCodes:Guid',
  BANKING_TAX_CODES_UPDATE_GUID = 'Banking:TaxCodes:Update:Guid',
  BANKING_TAX_CODES_DELETE_GUID = 'Banking:TaxCodes:Delete:Guid',
  BANKING_TRANSACTIONS_LOAD_NEW = 'Banking:Transactions:load_new',
  BANKING_TRANSACTIONS = 'Banking:Transactions',
  BANKING_TRANSACTIONS_GUID = 'Banking:Transactions:Guid',
  BANKING_TRANSACTIONS_UPDATE_GUID = 'Banking:Transactions:Update:Guid',
  BANKING_TRANSACTIONS_DELETE_GUID = 'Banking:Transactions:Delete:Guid',
  BANKING_TRANSACTIONS_FILES_GUID = 'Banking:Transactions:Files:Guid',
}
